module.exports = __webpack_public_path__ + "static/media/logo_msc.8e41f450.png";